import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../../../img/no-profile.jpg';
const _hoisted_1 = { class: "top_nav no-print" };
const _hoisted_2 = { class: "nav_menu" };
const _hoisted_3 = { class: "nav toggle" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-bars" }, null, -1 /* HOISTED */);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = {
    key: 0,
    class: "nav navbar-nav navbar-right"
};
const _hoisted_7 = { class: "hidden-xs" };
const _hoisted_8 = {
    href: "#",
    class: "user-profile",
    "data-toggle": "dropdown",
    "aria-expanded": "false",
    "data-display": "static"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-angle-down" }, null, -1 /* HOISTED */);
const _hoisted_11 = { class: "dropdown-menu dropdown-usermenu float-end do-not-attach-to-body" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", null, "My Profile", -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-power-off float-end" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("nav", null, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("a", {
                        id: "menu_toggle",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.menuClick && _ctx.menuClick(...args)))
                    }, _hoisted_5)
                ]),
                _createTextVNode(),
                (_ctx.showProfileLink)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                        _createElementVNode("li", _hoisted_7, [
                            _createElementVNode("a", _hoisted_8, [
                                _hoisted_9,
                                _createTextVNode(" " + _toDisplayString(_ctx.loginState.displayName) + " ", 1 /* TEXT */),
                                _hoisted_10
                            ]),
                            _createTextVNode(),
                            _createElementVNode("ul", _hoisted_11, [
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: { name: 'me' } }, {
                                        default: _withCtx(() => [
                                            _hoisted_12
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _createTextVNode(),
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, { to: { name: 'logout' } }, {
                                        default: _withCtx(() => [
                                            _hoisted_13,
                                            _createTextVNode(" Log Out\r\n\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ]));
}
